(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.filter('BoolToTextFilter', ['$translate', BoolToTextFilterFn]);

    // converts bool-values to text-values (true -> 'yes')
    function BoolToTextFilterFn($translate) {
        return function (boolValue) {
            if (boolValue) {
                return $translate.instant('yes'); 
            }

            return $translate.instant('no');
        };
    }
})();